import { Actions, createEffect, ofType } from "@ngrx/effects";
import { PriorityService } from "src/app/core/services/Priority/priority.service";
import { RiskService } from "src/app/core/services/Risk/risk.service";
import { SourceService } from "src/app/core/services/Source/source.service";
import * as actions from './constants.actions';
import { map, switchMap, tap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { userActions } from "../user";
import { ConstantState } from "./constants.reducers";

@Injectable()
export class ConstantsEffects {
    constructor(private actions$: Actions,
        private riskService: RiskService,
        private priorityService: PriorityService,
        private sourceService: SourceService) { }

    getPriorites$ = createEffect(() => this.actions$.pipe(
        ofType(actions.getPriorities),
        switchMap(() => this.priorityService.getPriorities()),
        tap(priorities => {
            const constString = localStorage.getItem('constants');
            let constants = { priorities: [], sources: [], riskLevels: [], categories: [] }
            if (constString) {
                constants = JSON.parse(constString);
            }
            constants.priorities = priorities;
            localStorage.setItem('constants', JSON.stringify(constants));
        }),
        map(priority => actions.prioritiesRetrieved({ priority }))
    ));

    getRisks$ = createEffect(() => this.actions$.pipe(
        ofType(actions.getRiskLevel),
        switchMap(() => this.riskService.getRisks()),
        tap(riskLevels => {
            const constString = localStorage.getItem('constants');
            let constants = { priorities: [], sources: [], riskLevels: [], categories: [] }
            if (constString) {
                constants = JSON.parse(constString);
            }
            constants.riskLevels = riskLevels;
            localStorage.setItem('constants', JSON.stringify(constants));
        }),
        map(riskLevel => actions.riskLevelRetrieved({ riskLevel }))
    ));

    getSources$ = createEffect(() => this.actions$.pipe(
        ofType(actions.getSources),
        switchMap(() => this.sourceService.getAllSources()),
        tap(sources => {
            const constString = localStorage.getItem('constants');
            let constants = { priorities: [], sources: [], riskLevels: [], categories: [] }
            if (constString) {
                constants = JSON.parse(constString);
            }
            constants.sources = sources;
            localStorage.setItem('constants', JSON.stringify(constants));
        }),
        map(source => actions.sourcesRetrieved({ source }))
    ));

    sendGetPriority$ = createEffect(() => this.actions$.pipe(
        ofType(userActions.userLoggedIn),
        map(() => actions.getPriorities())
    ));

    sendGetRiskLevel$ = createEffect(() => this.actions$.pipe(
        ofType(userActions.userLoggedIn),
        map(() => actions.getRiskLevel())
    ));

    sendGetSources$ = createEffect(() => this.actions$.pipe(
        ofType(userActions.userLoggedIn),
        map(() => actions.getSources())
    ));
}